import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    menuItem: {
      fontSize: 12,
      fontWeight: typography.fontWeightMedium,

      '&:hover': {
        backgroundColor: 'rgba(239, 205, 51, .15)',
      },
    },

    iconFormat: {
      color: palette.deepBlue,
    },
    strong: {
      fontWeight: 'bold',
    },
    rootBar: {
      marginTop: 32,
    },

    bar: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    },

    tab: {
      transition: 'background 250ms linear',

      '&:hover': {
        textDecoration: 'none',
      },

      '& .MuiTab-wrapper': {
        fontSize: 14,
        color: palette.gray,
      },

      '&.Mui-selected': {
        fontWeight: typography.fontWeightMedium,
        backgroundColor: 'rgba(239, 205, 51, .15)',
      },
    },

    sectionTitle: {
      margin: '60px 0 32px',
    },

    checkboxCell: {
      width: 10,
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },

    flagType: {
      display: 'block',
      color: palette.blue,
      border: `1px solid ${palette.blue}`,
      padding: '1px 6px',
      borderRadius: 5,
      fontSize: 12,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      textAlign: 'center',
    },
    isSpot: {
      display: 'block',
      color: palette.green,
      border: `1px solid ${palette.green}`,
      padding: '4px 8px',
      borderRadius: 5,
      fontSize: 12,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      textAlign: 'center',
    },
    cardTitle: {
      fontSize: 14,
      fontWeight: 500,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      textAlign: 'center',
    },
    cardSubtitle: {
      fontSize: 12,
      fontWeight: 500,
    },
    cards: { justifyContent: 'space-around' },
    metrics: {
      fontSize: 12,
      fontWeight: 'bold',
      textAlign: 'center',
      maxWidth: 35,
    },
    green: {
      backgroundColor: palette.lightGreen,
      color: palette.darkGreen,
    },
    yellow: {
      backgroundColor: palette.lightYellow,
      color: palette.darkYellow,
    },
    red: {
      backgroundColor: palette.lightRed,
      color: palette.darkRed,
    },
    amber: {
      backgroundColor: palette.lightAmber,
      color: palette.amber,
    },
    table: {
      '& th.MuiTableCell-root': {
        padding: '0px 8px',
      },

      '& td.MuiTableCell-root': {
        padding: '0px 8px',
      },
    },
    smallHeader: {
      fontSize: 12,
      color: palette.darkGray,
      maxWidth: 30,
      '& .makeStyles-cellContent-484': {
        justifyContent: 'center',
      },
    },
    statusHeader: {
      fontSize: 12,
      color: palette.darkGray,
      maxWidth: 100,
      '& .makeStyles-alingCenterSpan-488': {
        justifyContent: 'center',
        maxWidth: 100,
      },
    },
    statusCell: {
      width: 60,
    },
    instanceCell: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: 12,
      color: palette.darkGray,
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
    },
    instanceCellName: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: 150,
      width: '100%',
      textOverflow: 'ellipsis',
      fontSize: 12,
      color: palette.darkGray,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    sessionsTimeoutAlertIcon: {
      width: 16,
      height: 16,
      marginRight: 10,
    },
    accessTimeIcon: {
      cursor: 'pointer',
      width: 16,
      height: 16,
      marginRight: 10,
    },
    enabledZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.green,
    },
    failedZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.grey700,
    },
    disabledZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.grey400,
    },
    startingZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.yellow,
    },
    dateTimeTooltip: {
      margin: '0px 5px',
      fontWeight: 500,
      alignItems: 'center',
      display: 'flex',
      fontSize: 12,
      color: palette.white,
    },
    detailsTooltip: {
      margin: '0px 5px',
      fontWeight: 600,
      alignItems: 'center',
      display: 'flex',
      fontSize: 12,
      color: palette.white,
    },
    dateTime: {
      margin: '0px 5px',
      fontWeight: 500,
      alignItems: 'center',
      display: 'flex',
      fontSize: 12,
    },
    instanceIdDetail: {
      color: palette.blue,
      margin: '0px 5px',
      fontSize: 12,
      fontWeight: 500,
      maxWidth: '60%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    center: { justifyContent: 'center', fontSize: 12 },
    text: { fontSize: 12 },
    IPs: { width: 60, fontSize: 12, color: palette.darkGray },
    flavor: { width: 140, fontSize: 12, color: palette.darkGray },
    modalText: { fontSize: 12 },
    initializingMsg: {
      '& .MuiTypography-root': {
        fontSize: 14,
      },
      gap: '8px',
    },
    divValue: {
      display: 'flex',
      flexDirection: 'row',
      lineHeight: '0px',
      fontSize: 12,
    },
    divValueHeight: {
      display: 'flex',
      flexDirection: 'row',
      lineHeight: '0px',
      fontSize: 12,
      margin: '22px 0px 8px 0px',
    },
    tooltip: {
      lineHeight: '0px !important',
      '& .MuiTooltip-tooltip': {
        lineHeight: '0px !important',
      },
    },
    noMaxWidth: {
      maxWidth: 'none',
      display: 'grid',
      alignItems: 'center',
    },
    validateButton: {
      color: palette.blue,
      borderColor: palette.blue,
      marginBottom: 24,
    },
    trueOption: {
      color: palette.green,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
    falseOption: {
      color: palette.red,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
    blueOption: {
      color: palette.blue,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
    containerInfoZeroTrust: { display: 'grid', marginBottom: 24 },
    itemInfoZeroTrust: { display: 'flex' },
    itemInfoZeroTrustPlatform: { display: 'block' },
    infoZeroTrustTitle: {
      fontSize: 12,
      color: palette.dark,
      display: 'flex',
      margin: 4,
    },
    itemInfoPlatformVersion: { display: 'block', marginLeft: 32 },
    validZeroTrust: {
      color: palette.green,
      fontSize: 16,
    },
    invalidZeroTrust: {
      color: palette.red,
      fontSize: 16,
    },
    warningZeroTrust: {
      color: palette.darkYellow,
      fontSize: 16,
    },
    zeroTrustStatusValid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundLightGreen,
      padding: '4px 12px',
      borderRadius: 16,
    },
    zeroTrustStatusInvalid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundSuperLightRed,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusZeroTrustIconValid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.status.success,
    },
    statusZeroTrustIconInvalid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.red,
    },
    statusZeroTrustIconNotApplicable: {
      fontSize: 16,
      marginRight: 6,
      color: palette.blue,
    },
    zeroTrustStatusWarning: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.superLightYellow,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusZeroTrustIconWarning: {
      fontSize: 16,
      marginRight: 6,
      color: palette.darkYellow,
    },
    isLoading: { margin: 123, padding: '0px 100px' },
    renderStatus: { margin: '8px 0px 24px 0px' },
    detailsButtons: {
      color: palette.blue,
      borderColor: palette.blue,
      margin: '0px 4px',
    },
    detailsButtonsExpand: {
      color: palette.blue,
      borderColor: palette.blue,
      margin: '0px 4px 0px 0px',
      padding: '5px 15px 5px 22px',
    },
    detailsButtonsExpandBack: {
      color: palette.blue,
      borderColor: palette.blue,
      margin: '0px 4px',
      padding: '14px 0px',
      minWidth: '32px',
    },
    buttonsGrid: { margin: 8 },
    closeIcon: {
      color: palette.red,
      height: '50%',
      margin: '12px 12px 0px 0px',
      padding: 0,
    },
    closeIconDetails: { fontSize: 16 },
    emptyInstanceDetails: {
      alignItems: 'center',
      display: 'flex',
      marginTop: 22,
    },
    infoIcon: {
      color: palette.blue,
      marginRight: 4,
      fontSize: 30,
      animation: '$infoIcon 2s linear infinite',
    },

    '@keyframes infoIcon': {
      '0%': {
        transform: 'rotateZ(0)',
      },
      '7%': {
        transform: 'rotateZ(0)',
      },
      '15%': {
        transform: 'rotateZ(-15deg)',
      },
      '20%': {
        transform: 'rotateZ(10deg)',
      },
      '25%': {
        transform: 'rotateZ(-10deg)',
      },
      '30%': {
        transform: 'rotateZ(6deg)',
      },
      '35%': {
        transform: 'rotateZ(-4deg)',
      },
      '40%': {
        transform: 'rotateZ(0)',
      },
      '100%': {
        transform: 'rotateZ(0)',
      },
    },
    instanceIcon: { opacity: 0.6, marginRight: 8 },
    instanceInfo: {
      display: 'flex',
      alignItems: 'center',
      margin: 8,
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: '8px',
    },
    instanceInfoStatus: {
      display: 'grid',
      alignItems: 'center',
      margin: 8,
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: '8px',
    },
    detailsIcon: { fontSize: 24, color: palette.gray, marginRight: 8 },
    buttonRemove: {
      color: palette.error.light,
      '&:hover': {
        color: palette.error.main,
      },
      borderColor: palette.black,
      padding: '2px !important',
    },
    instanceName: {
      margin: '0px 5px',
      fontSize: 14,
    },
    arrowIconButton: {
      width: 16,
      height: 30,
      position: 'absolute',
      animation: '$arrowIconButton 1.5s infinite',
      color: palette.blue,

      '&:after': {
        content: '""',
        position: 'absolute',
        top: 12,
        left: -10,
        width: 16,
        height: 16,
        borderBottom: '4px solid',
        borderRight: '4px solid',
        borderRadius: 4,
        transform: 'rotateZ(45deg)',
      },
    },

    '@keyframes arrowIconButton': {
      '0%': {
        marginLeft: 0,
      },
      '50%': {
        marginLeft: 6,
      },
      '100%': {
        marginLeft: 0,
      },
    },
    displayAndAlign: { display: 'flex', alignItems: 'center' },
    displayAndAlignLogin: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    displayAndAlignIp: {
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
    },
    platformVersionDetails: {
      fontSize: 12,
      fontWeight: 500,
    },
    detailHeaderText: { margin: '0px 5px', fontSize: 14 },
    section: {},
    loginType: { fontSize: 12, color: palette.darkGray, marginRight: 2 },
    helpIcon: { height: 13, width: 13 },
    ellipsisTableCell: {
      maxWidth: 100,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 12,
      color: palette.darkGray,
    },
    bottomPage: { marginBottom: 17 },
    removeButton: {
      color: palette.error.main,
      marginRight: 8,
      fontSize: 12,
      padding: '5px 8px',

      '&:hover': {
        backgroundColor: 'rgba(239, 205, 51, .15)',
      },

      '& .MuiButton-startIcon': {
        marginRight: '0 !important',
      },
    },
    keyboardIcon: { height: 20 },
    tableCellInstanceId: { whiteSpace: 'nowrap' },
    tableCellFlavor: { maxWidth: 'auto', width: 'auto' },
    tableCellMenuOptions: { width: 10, textAlign: 'center' },
    benchmarkNull: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.grey700,
    },
    benchmarkLow: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.dashRed,
    },
    benchmarkModerate: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.dashYellow,
    },
    benchmarkModerateToHigh: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.autoSkyBlue,
    },
    benchmarkHigh: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.dashGreen,
    },
  });

export const styleStatus = () =>
  createStyles({
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 15,
      height: 15,
      borderRadius: '50%',
      color: palette.white,
      marginRight: 5,
    },

    blue: { backgroundColor: palette.blue },
    green: { backgroundColor: palette.green },
    orange: { backgroundColor: palette.orange },
    red: { backgroundColor: palette.red },
    gray: { backgroundColor: palette.gray },

    textOpacity: {
      fontSize: 10,
      color: palette.darkGray,
      fontWeight: 500,
      marginRight: 5,
    },
  });

export const overrideModalSimulate = {
  content: {
    padding: 12,
    maxHeight: 600,
    overflowX: 'auto',
    fontSize: '12px !important',
  },
};

export const overrideModalTestZeroTrust = {
  content: {
    padding: 12,
    maxHeight: 600,
    overflowX: 'auto',
    fontSize: '12px !important',
    maxWidth: 450,
  },
};
